import React, {Component} from 'react';
import routes from "../../helpers/exportRoutes";
import icon from "../../components/header/resources/icon.png";
import {title} from "../../helpers/exportConsts";
import "./Developer.scss";

class Developers extends Component{
  render() {
    return (
      <div className="container Game">
        <br/>
        <div className="row info-panel">
          <div className="row px-3 py-2">
            <a className="navbar-brand" href={routes.landing}>
              <img src={icon} className="icon d-inline-block align-top" alt="logo" />
              {title('2.5rem')}
            </a>
            <p>
              Oneside represents one side of the rubik's cube, where each cell has a randomly generated number.
              The goal is to start from an ordered sequence and use swapping operations to reach the randomly
              generated sequence in minimum number of moves.
              <br/> Hope you enjoy!
            </p>
            <div className="row">
              <strong>Github : &nbsp;</strong>
              <a href={'https://github.com/shubheshdwivedi/oneside'}>https://github.com/shubheshdwivedi/oneside</a>
            </div>
          </div>
          <div className="row developers px-3 py-3">
            <div className="row mb-3" style={{width: '100%'}}>
              <h3>Developers</h3>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="card" style={{width: '18rem'}}>
                  <div className="card-body">
                    <h5 className="card-title"><strong>Harishiv Singh</strong></h5>
                    <h6 className="card-subtitle mb-2 ">Designation</h6>
                    <p className="card-text">Something about me! A brief secription.</p>
                    <a href="#" className="card-link">Github</a>
                    <a href="#" className="card-link">LinkedIn</a>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="card" style={{width: '18rem'}}>
                  <div className="card-body">
                    <h5 className="card-title"><strong>Shubhesh Dwivedi</strong></h5>
                    <h6 className="card-subtitle mb-2 ">Clockwork Ninja!</h6>
                    <p className="card-text">I can make computers do stuff!</p>
                    <a href="https://github.com/shubheshdwivedi" className="card-link">Github</a>
                    <a href="#" className="card-link">LinkedIn</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Developers;